import BillingRecurringChargeLayout from "components/billing-module/billing-recurring-charge/BillingRecurringChargeLayout";

const BillingRecurringCharge = () => {
  return <BillingRecurringChargeLayout />;
};

export default BillingRecurringCharge;
